import { prepareFormData } from '@/store/utils/formDataHelper';
import { Action, getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store'
import { IVisitCategories, IVisitCategoriesListItem, VisitCategoriesResponseType } from '@/entity/visits/visitCategories.types';
import { PaginationRequestType } from '@/entity/common/pagination.types'
import { VisitsCategoriesSettingsRequestType } from '@/form/Settings/categories/visits.types';

import { ResponseDataType } from '@/form/form.types'
@Module({
    namespaced: true,
    name: 'visitCategories',
    store,
    dynamic: true
})
class VisitsCategoriesSettingsModule extends VuexModule {
    visitCategories: IVisitCategories | null = null;
    visitCategory: IVisitCategoriesListItem | null = null;
    visitCategoriesLoaded = false;
    visitCategoryLoaded = false;
    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ visitCategories: IVisitCategories; visitCategoriesLoaded: boolean }> {
    
        let visitCategoriesLoaded = false;
        console.log('Client category settings query vuex - ')
        const visitCategories = await store.$repository.visitsCategory.fetchAll(prepareFormData(data));
        console.log('Client category settings query vuex - ')
        console.log(visitCategories);
        if (visitCategories) {
            visitCategoriesLoaded = true;
        }
        return { visitCategories, visitCategoriesLoaded };
    }
    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ visitCategory: IVisitCategoriesListItem; visitCategoryLoaded: boolean }> {
        console.log('Client query vuex fetch Data - ')
        let visitCategoryLoaded = false;
        const visitCategory = await store.$repository.visitsCategory.fetchData(data);
        if (visitCategory) {
            visitCategoryLoaded = true;
        }
        return { visitCategory, visitCategoryLoaded };
    }
    @Action({ rawError: true })
    async create(data: VisitsCategoriesSettingsRequestType): Promise<ResponseDataType> {
        return await store.$repository.visitsCategory.create(data);
    }
    @Action({ rawError: true })
    async update(data: VisitsCategoriesSettingsRequestType): Promise<ResponseDataType> {
        return  await store.$repository.visitsCategory.update(data);
    }
    @Action({ rawError: true })
    async delete(data: { id: number }): Promise<ResponseDataType> {
        return await store.$repository.visitsCategory.delete(data);
    }
}

export const VisitsCategoriesSettingsStore = getModule(VisitsCategoriesSettingsModule);
